<template>
  <b-overlay :show="overlay" rounded="sm">
    <div>
      <user-list-add-new
          :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive"
          @refetch-data="refreshData"
      />

      <b-card no-body class="mb-0">
        <div class="m-2">
          <b-row>
            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <span> تعداد کاربران : </span>
              <span class="mx-1">{{ totalCounts }}</span>
              <span>نفر</span>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>

            <b-col
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perState"
                  :options="perStateOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
              <label>وضعیت</label>
            </b-col>

            <b-col cols="12" md="5">
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="debouncedSearch"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
                <b-button
                    variant="primary"
                    @click="isAddNewUserSidebarActive = true"
                >
                  <span class="text-nowrap">اضافه کردن کاربر</span>
                </b-button>
              </div>
            </b-col>

            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
                cols="12"
                md="3"
            >
              <label>نمایش افراد مسدود شده</label>
              <v-select
                  v-model="isBlocked"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="blockList"
                  :reduce="(val) => val.value"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
            </b-col>

            <b-col
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0 mt-1"
                cols="12"
                md="3"
            >
              <label>ملیت کاربران</label>
              <v-select
                  v-model="isIranian"
                  :clearable="false"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="nationalityList"
                  :reduce="(val) => val.value"
                  class="per-page-selector d-inline-block mx-50 w-50"
              />
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start my-1 mb-md-0"
            >
              <b-button
                  variant="success"
                  class=""
                  :block="$store.getters['app/currentBreakPoint'] === 'xs'"
                  @click="downloadFile"
              >
                دانلود اکسل لیست
              </b-button>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="users"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <!-- شماره ردیف -->
          <template #cell(rowNumber)="data">
            {{ getRowNumber(data.index) }}
          </template>

          <template #cell(name)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="baseUrl + data.item.selfieFileData"
                    :variant="`success`"
                    :to="{
                    name: 'apps-users-edit',
                    params: { id: data.item.userId },
                  }"
                />
              </template>
              <b-link
                  :to="{
                  name: 'apps-users-edit',
                  params: { id: data.item.userId },
                }"
                  class="font-weight-bold d-block text-nowrap"
              >
                {{ data.item.name + " " + data.item.familyName }}
              </b-link>
              <small class="text-muted">@{{ data.item.userId }}</small>
            </b-media>
          </template>

          <template #cell(type)="data">
            <b-badge pill class="text-capitalize" :variant="``">
              {{ data.item.type }}
            </b-badge>
          </template>

          <template #cell(state)="data">
            <b-badge
                v-if="data.item.state === 1"
                pill
                class="text-capitalize"
                :variant="`success`"
            >
              وارد شده
            </b-badge>
            <b-badge
                v-else-if="data.item.state === 2"
                pill
                class="text-capitalize"
                :variant="`warning`"
            >
              فالو نکرده
            </b-badge>
            <b-badge
                v-else-if="data.item.state === 3"
                pill
                class="text-capitalize"
                :variant="`danger`"
            >
              آیدی اشتباه
            </b-badge>
          </template>

          <template #cell(edit)="data">
            <b-link
                :to="{
                name: 'apps-users-edit',
                params: { id: data.item.userId },
              }"
            >
              <feather-icon icon="EditIcon" size="20" />
            </b-link>
          </template>

          <template #cell(buy)="data">
            <b-link
                :to="{ name: 'apps-buy-id', params: { id: data.item.userId } }"
            >
              <feather-icon icon="ShoppingCartIcon" size="20" />
            </b-link>
          </template>

          <template #cell(buyed)="data">
            <b-link
                :to="{
                name: 'apps-users-buyed',
                params: { id: data.item.userId },
              }"
            >
              <feather-icon icon="ClipboardIcon" size="20" />
            </b-link>
          </template>

          <template #cell(chat)="data">
            <b-link
                :to="{ name: 'apps-chats-id', params: { id: data.item.userId } }"
            >
              <feather-icon icon="MessageCircleIcon" size="20" />
            </b-link>
          </template>

          <template #cell(createDate)="data">
            <small class="">
              {{ data.item.createDate.slice(11, 16) }}
              -
              {{ createJalaliDate(data.item.createDate.slice(0, 10)) }}
            </small>
          </template>
        </b-table>

        <div class="mx-2 mb-2">
          <b-row>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            ></b-col>
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <QueriedPagination
                  v-if="totalCounts"
                  v-model="currentPage"
                  :total-counts="totalCounts"
                  :per-page="perPage"
              ></QueriedPagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </b-overlay>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCard,
  BCol,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BLink,
  BMedia,
  BOverlay,
  BPagination,
  BRow,
  BTable,
} from "bootstrap-vue";
import vSelect from "vue-select";
import UsersListFilters from "./UsersListFilters.vue";
import UserListAddNew from "./UserListAddNew.vue";
import { UsersGetAllRequest } from "@/libs/Api/Users";
import { getUserData } from "@/auth/utils";
import axiosIns from "@/libs/axios";
import { saveAs } from "file-saver";
import Helper from "@/libs/Helper";
import QueriedPagination from "@/views/components/QueriedPagination.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  title: "لیست کاربران - پنل ادمین بنفشه باقری",
  data() {
    return {
      users: [],
      baseUrl: Helper.baseUrl,
      overlay: false,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      perState: "",
      suspicious: false,
      perStateOptions: [
        { label: "همه", value: "" },
        { label: "وارد شده", value: 1 },
        { label: "فالو نکرده", value: 2 },
        { label: "آیدی اشتباه", value: 3 },
      ],
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        { key: "rowNumber", label: "ردیف", sortable: false, thStyle: { width: "60px" } },
        { key: "name", label: "نام کامل" },
        { key: "createDate", label: "تاریخ ثبت نام" },
        { key: "state", label: "وضعیت" },
        { key: "mobile", label: "موبایل" },
        { key: "edit", label: "ویرایش کاربر" },
        { key: "buy", label: "ثبت سفارش" },
        { key: "buyed", label: "لیست خرید‌ها" },
      ],
      blockList: [
        { label: "همه", value: null },
        { label: "مسدود شده", value: true },
        { label: "مسدود نشده", value: false },
      ],
      nationalityList: [
        { label: "همه", value: null },
        { label: "کابران ایرانی", value: true },
        { label: "کاربران اتباع", value: false },
      ],
      searchQuery: "",
      timeOut: null,
      isAddNewUserSidebarActive: false,
      isBlocked: null,
      isIranian: null,
    };
  },
  async created() {
    await this.getUsers();
    if (this.$route.query.pageNumber) {
      this.currentPage = +this.$route.query.pageNumber;
    }
  },
  methods: {
    refreshData() {
      this.getUsers();
    },
    getRowNumber(index) {
      const page = Number(
          this.$route.query.pageNumber
              ? this.$route.query.pageNumber
              : this.currentPage
      );
      const perPage = Number(this.perPage) || 10;
      const safePage = Number.isFinite(page) && page > 0 ? page : 1;
      return (safePage - 1) * perPage + index + 1;
    },
    async getUsers() {
      let _this = this;
      _this.overlay = true;
      let data = {
        pageNumber: _this.$route.query.pageNumber
            ? _this.$route.query.pageNumber
            : _this.currentPage,
        count: _this.perPage,
        search: _this.searchQuery,
        state: _this.perState,
        isBlocked: _this.isBlocked ?? "",
        IsIranin: _this.isIranian ?? "",
      };

      let usersGetAllRequest = new UsersGetAllRequest(_this);
      usersGetAllRequest.setParams(data);
      await usersGetAllRequest.fetch(
          function (content) {
            _this.overlay = false;
            _this.users = content.users;
            _this.totalCounts = content.usersCount;
          },
          function (error) {
            _this.overlay = false;
          }
      );
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR");
    },
    async downloadFile() {
      this.$store.commit("app/TOGGLE_DOWNLOAD");

      await axiosIns
          .post("Users/GetUserExcel", null, { responseType: "blob" })
          .then((resp) => {
            saveAs(resp.data, "لیست کاربران.xlsx");
          })
          .catch(() => {
            this.$toast({
              component: ToastificationContent,
              position: "bottom-center",
              props: {
                title: "عملیات ناموق!",
                icon: "CheckIcon",
                variant: "danger",
                text: "به علت ترافیک بالا سرور لطفا 30 دقیقه دیگر امتحان کنید",
              },
            });
          })
          .finally(() => {
            this.$store.commit("app/TOGGLE_DOWNLOAD");
          });
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getUsers();
    },
    getQuery: function (nv, ov) {
      this.getUsers();
    },
    searchQuery: function (nv, ov) {
      this.getUsers();
    },
    perState: function (nv, ov) {
      this.getUsers();
    },
    isBlocked: function (nv, ov) {
      this.getUsers();
    },
    isIranian: function (nv, ov) {
      this.getUsers();
    },
  },
  computed: {
    getQuery() {
      return this.$route.query;
    },
    debouncedSearch: {
      get() {
        return this.searchQuery;
      },
      set(val) {
        if (this.timeOut) {
          clearTimeout(this.timeOut);
        }
        this.timeOut = setTimeout(() => {
          this.searchQuery = val;
        }, 600);
      },
    },
  },
  components: {
    QueriedPagination,
    BFormGroup,
    BFormCheckbox,
    UsersListFilters,
    UserListAddNew,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BPagination,
    BOverlay,
    vSelect,
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>